export const REPORT_FILTER_STICKY_ID = 'report-filter-panel-sticky';
export const REPORT_FILTER_STICKY_TOP = 12;
export const REPORT_FILTER_STICKY_TOP_POLARIS = `${12 * 25}`;
